import { ATTENDANCE_LIST } from '../actions';

export default ( state = [], action ) => {
	switch ( action.type ) {
		case ATTENDANCE_LIST:
			action.payload['time'] = Date.now() + 30000;
			return  action.payload;
			break;
	}
	return state;
}